// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg width=%2712%27 height=%2710%27 viewBox=%270 0 12 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 5L4.2 8L11 1%27 stroke=%27white%27 stroke-width=%272%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalProducts_modalBackdrop__-xm0p {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.ModalProducts_modalContent__3\\+szD {
  background: #fff;
  width: 90%;
  max-width: 900px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90%;
}

.ModalProducts_modalHeader__rzRlL {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #ddd;
}

.ModalProducts_closeBtn__C9WVh {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.ModalProducts_filters__ceWwM {
  padding: 12px 16px;
  border-bottom: 1px solid #ddd;
  box-sizing: border-box;
  width: 100%;
}

.ModalProducts_filtersTop__\\+r9Ps,
.ModalProducts_filtersBottom__Xx0t8 {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.ModalProducts_filters__select__6XRsf {
  min-width: 150px;
  max-width: 210px;
  flex: 1 1 auto;
  border-radius: 4px;
  font-size: 14px;
}

.ModalProducts_input__p3745 {
  min-width: 150px;
  max-width: 250px;
  flex: 1 1 auto;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.ModalProducts_input__p3745[type="date"] {
  padding: 5px 10px;
}

@media (max-width: 600px) {
  .ModalProducts_filters__select__6XRsf,
  .ModalProducts_input__p3745 {
    flex: 1 1 100%;
  }
}


.ModalProducts_tableContainer__zu95Q {
  overflow-y: auto;
  flex: 1 1;
}

.ModalProducts_modalTable__bx-xh {
  width: 100%;
  border-collapse: collapse;
}

.ModalProducts_modalTable__bx-xh th, .ModalProducts_modalTable__bx-xh td {
  border-bottom: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.ModalProducts_modalTable__bx-xh th {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}

.ModalProducts_modalFooter__ECSIy {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
  gap: 10px;
}

.ModalProducts_cancelBtn__fO2R8 {
  background: #ddd;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  border-radius: 5px;

}

.ModalProducts_addBtn__8yoey {
  color: white;
  background: rgba(29, 135, 82, 1);
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  border-radius: 5px;
}

.ModalProducts_checkboxContainer__6YHrX {
  display: inline-block;
  position: relative;
  cursor: pointer;
  width: 18px;
  height: 18px;
}

.ModalProducts_checkboxContainer__6YHrX input {
  opacity: 0;
  width: 0;
  height: 0;
}

.ModalProducts_customCheckbox__5IWqs {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: white;
  border: 2px solid #1D8752;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.ModalProducts_checkboxContainer__6YHrX input:checked + .ModalProducts_customCheckbox__5IWqs {
  background-color: #1D8752;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
}

.ModalProducts_tabsHeader__tCo3K {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding: 0 16px;
  position: relative;
}

.ModalProducts_tab__qtCH5 {
  padding: 12px 20px;
  cursor: pointer;
  font-weight: 500;
  margin-right: 10px;
}

.ModalProducts_activeTab__cWHCW {
  border-bottom: 3px solid rgba(29, 135, 82, 1);
  font-weight: 700;
}

.ModalProducts_disabledTab__LwKfG {
  opacity: 0.5;
  cursor: not-allowed;
}

.ModalProducts_closeBtn__C9WVh {
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.ModalProducts_input__p3745 {
  flex: 1 1;
  padding: 10px 15px;
  font-size: 16px;
  border-radius: 8px;
  background: white;
  border: 1px solid #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/styles/ModalProducts.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;IAEE,cAAc;EAChB;AACF;;;AAGA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;;AAEpB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yDAAsO;EACtO,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB","sourcesContent":[".modalBackdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background: #fff;\n  width: 90%;\n  max-width: 900px;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  max-height: 90%;\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  padding: 16px;\n  border-bottom: 1px solid #ddd;\n}\n\n.closeBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.filters {\n  padding: 12px 16px;\n  border-bottom: 1px solid #ddd;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.filtersTop,\n.filtersBottom {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.filters__select {\n  min-width: 150px;\n  max-width: 210px;\n  flex: 1 1 auto;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.input {\n  min-width: 150px;\n  max-width: 250px;\n  flex: 1 1 auto;\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.input[type=\"date\"] {\n  padding: 5px 10px;\n}\n\n@media (max-width: 600px) {\n  .filters__select,\n  .input {\n    flex: 1 1 100%;\n  }\n}\n\n\n.tableContainer {\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modalTable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.modalTable th, .modalTable td {\n  border-bottom: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n}\n\n.modalTable th {\n  position: sticky;\n  top: 0;\n  background: #fff;\n  z-index: 1;\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px;\n  gap: 10px;\n}\n\n.cancelBtn {\n  background: #ddd;\n  border: none;\n  padding: 8px 16px;\n  cursor: pointer;\n  border-radius: 5px;\n\n}\n\n.addBtn {\n  color: white;\n  background: rgba(29, 135, 82, 1);\n  border: none;\n  padding: 8px 16px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.checkboxContainer {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n}\n\n.checkboxContainer input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.customCheckbox {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 18px;\n  width: 18px;\n  background-color: white;\n  border: 2px solid #1D8752;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.checkboxContainer input:checked + .customCheckbox {\n  background-color: #1D8752;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L4.2 8L11 1' stroke='white' stroke-width='2'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.tabsHeader {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #ddd;\n  padding: 0 16px;\n  position: relative;\n}\n\n.tab {\n  padding: 12px 20px;\n  cursor: pointer;\n  font-weight: 500;\n  margin-right: 10px;\n}\n\n.activeTab {\n  border-bottom: 3px solid rgba(29, 135, 82, 1);\n  font-weight: 700;\n}\n\n.disabledTab {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.closeBtn {\n  margin-left: auto;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.input {\n  flex: 1 1;\n  padding: 10px 15px;\n  font-size: 16px;\n  border-radius: 8px;\n  background: white;\n  border: 1px solid #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalBackdrop": `ModalProducts_modalBackdrop__-xm0p`,
	"modalContent": `ModalProducts_modalContent__3+szD`,
	"modalHeader": `ModalProducts_modalHeader__rzRlL`,
	"closeBtn": `ModalProducts_closeBtn__C9WVh`,
	"filters": `ModalProducts_filters__ceWwM`,
	"filtersTop": `ModalProducts_filtersTop__+r9Ps`,
	"filtersBottom": `ModalProducts_filtersBottom__Xx0t8`,
	"filters__select": `ModalProducts_filters__select__6XRsf`,
	"input": `ModalProducts_input__p3745`,
	"tableContainer": `ModalProducts_tableContainer__zu95Q`,
	"modalTable": `ModalProducts_modalTable__bx-xh`,
	"modalFooter": `ModalProducts_modalFooter__ECSIy`,
	"cancelBtn": `ModalProducts_cancelBtn__fO2R8`,
	"addBtn": `ModalProducts_addBtn__8yoey`,
	"checkboxContainer": `ModalProducts_checkboxContainer__6YHrX`,
	"customCheckbox": `ModalProducts_customCheckbox__5IWqs`,
	"tabsHeader": `ModalProducts_tabsHeader__tCo3K`,
	"tab": `ModalProducts_tab__qtCH5`,
	"activeTab": `ModalProducts_activeTab__cWHCW`,
	"disabledTab": `ModalProducts_disabledTab__LwKfG`
};
export default ___CSS_LOADER_EXPORT___;
